import { t } from 'i18next';

import { CRUSTS } from '~screens/Dashboard/screens/Home/constants';
import { SHOPPING_CART_TARGET } from '~screens/Dashboard/screens/Home/redux/constants';
import { EVENT } from '~utils/analytics';
import { formatPrice } from '~utils/number';
import { camelize } from '~utils/stringFunction';

import { NOUN_NUMBER, VARIANT_TYPES } from './constants';
import styles from './styles.module.scss';

export const shoppingCartLoadingSelector = state => state.home?.shoppingCartLoading;
export const itemsSelector = state => state.home[SHOPPING_CART_TARGET]?.items;

export const getVariantType = crust => {
  if ([CRUSTS.STUFFED, CRUSTS.PARMESAN, CRUSTS.PHILADELPHIA].includes(crust)) {
    return VARIANT_TYPES.CRUST_AND_DOUGH;
  }
  return crust ? VARIANT_TYPES.CRUST : VARIANT_TYPES.SIZE;
};

export const getTextAndClasses = isUpgraded =>
  isUpgraded
    ? {
        gtmEventName: EVENT.REMOVE_UPSELLING,
        animationHidden: styles.hidden
      }
    : {
        hidden: styles.hidden,
        gtmEventName: EVENT.ADD_UPSELLING
      };

export const normalizeVariantName = (variant, crusts, sizes) =>
  ({
    [CRUSTS.STUFFED]: t('UpsellingOption:crustVariant', {
      crust: crusts?.[CRUSTS.TRADITIONAL],
      crustVariant: crusts?.[CRUSTS.STUFFED]
    }),
    [CRUSTS.PARMESAN]: t('UpsellingOption:crustVariant', {
      crust: crusts?.[CRUSTS.TRADITIONAL],
      crustVariant: crusts?.[CRUSTS.PARMESAN]
    }),
    [CRUSTS.PHILADELPHIA]: t('UpsellingOption:crustVariant', {
      crust: crusts?.[CRUSTS.TRADITIONAL],
      crustVariant: crusts?.[CRUSTS.PHILADELPHIA]
    })
  }?.[variant] ||
  crusts?.[camelize(variant)] ||
  sizes?.[camelize(variant)]);

export const getTransComponentProps = ({
  productName,
  variant,
  variantType,
  itemCategory,
  verbTense,
  productCategory,
  nounNumber,
  price,
  crusts,
  sizes
}) => ({
  i18nKey: `UpsellingOption:description.${variantType}.${itemCategory}`,
  values: {
    verb: t(`UpsellingOption:verbs.${variantType}.${verbTense}`),
    productSpecification: t(`UpsellingOption:products.${productCategory}.${nounNumber}`, {
      name: productName
    }),
    variantName: normalizeVariantName(variant, crusts, sizes),
    price: formatPrice(price),
    eachOne: nounNumber === NOUN_NUMBER.PLURAL ? t('UpsellingOption:eachOne') : ''
  }
});

export const getOfferProduct = (offer, offerGroupId) =>
  offer?.groupProducts?.find(product => product?.offerGroupId === offerGroupId);
